module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-collector-1.9fa1adf9.svg";